// extracted by mini-css-extract-plugin
export default {"container":"Index_container__9--06","left":"Index_left__6nyu-","right":"Index_right__WKPhP","links":"Index_links__faAda"};